module.exports = __webpack_public_path__ + "static/media/ai.4ccf1365.svg";